import SearchControl from "@components/SearchControl";
import useSwiper from "@hooks/useSwiper";
import cx from "classnames";
import _ from "lodash";
import React from "react";
import { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import styles from "./Banner.module.scss";
import SlideItem from "./SlideItem";
// import { useTranslationContext } from "@providers/TranslationProvider";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";

const View = () => {
  // const [activeIndex, $activeIndex] = React.useState(0);
  const { pageData } = usePageContext();
  // const { i18n } = useTranslationContext();
  const {
    isAuto,
    interval = 3000,
    slides,
  } = helper.formatBannerSlider(pageData);
  useSwiper(".home-swiper", {
    speed: 1000,
    centeredSlides: true,
    allowTouchMove: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    autoplay: !!isAuto && {
      delay: interval,
      disableOnInteraction: false,
    },
    modules: [Autoplay],
    on: {
      slideChange: (swiper) => {
        if (swiper) {
          // $activeIndex(swiper.realIndex);
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
  });

  const slidesData = _.map(slides, (slide) => {
    return {
      image: slide.image,
      title: <div className={styles.message1}>{slide.title}</div>,
    };
  });
  return (
    <section data-scroll-section className={styles.swiper}>
      <div className={cx("swiper home-swiper")}>
        <div className="swiper-wrapper">
          {_.map(slidesData, (item, index: number) => {
            return (
              <SlideItem
                className="swiper-slide"
                key={`slide_${""}_${index}`}
                {...item}
              />
            );
          })}
        </div>
        <div className={cx(styles.scrollbar, "swiper-scrollbar")}></div>
      </div>
      <div className={styles.searchControl}>
        <SearchControl type="responsive" />
      </div>
    </section>
  );
};
export default View;
